import { render, staticRenderFns } from "./pageTwo.vue?vue&type=template&id=32c0756e&scoped=true&"
import script from "./pageTwo.vue?vue&type=script&lang=js&"
export * from "./pageTwo.vue?vue&type=script&lang=js&"
import style0 from "./pageTwo.vue?vue&type=style&index=0&id=32c0756e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c0756e",
  null
  
)

export default component.exports